import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/styles.scss';
import App from './App';

import { CookiesProvider } from 'react-cookie';

import { CoreProvider } from './hooks/useCore';
import { AuthProvider } from './hooks/useAuth';
import { DataProvider } from './hooks/useData';
import { OrganizationProvider } from './hooks/useOrganization';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CookiesProvider>
    <CoreProvider>
      <AuthProvider>
        <OrganizationProvider>
          <DataProvider>
            <App />
          </DataProvider>
        </OrganizationProvider>
      </AuthProvider>
    </CoreProvider>
  </CookiesProvider>
);


reportWebVitals();
